import multiGuard from '@/router/utils/vue-router-multiguard'
import PackagePermissionsGuard from '@/router/guards/package-permissions-guard'
import { PACKAGE_PERMISSIONS } from '@/constants/features'
import USER_TYPES from '@/constants/authorization/user-types'

export default [
  {
    path: 'surveys',
    name: 'admin:surveys',
    beforeEnter: multiGuard([PackagePermissionsGuard]),
    meta: { packagePermissions: [PACKAGE_PERMISSIONS.FEEDBACK], userTypes: [USER_TYPES.OWNER] },
    component: () => import(/* webpackChunkName: "surveys" */ '@/views/admin/marketing/surveys/SurveysWizard.vue'),
  },
  {
    path: 'surveys/edit/:id?',
    alias: 'surveys/add',
    name: 'admin:surveys:form',
    beforeEnter: multiGuard([PackagePermissionsGuard]),
    meta: { packagePermissions: [PACKAGE_PERMISSIONS.FEEDBACK], userTypes: [USER_TYPES.OWNER] },
    component: () => import(/* webpackChunkName: "surveys" */ '@/views/admin/marketing/surveys/SurveyForm.vue'),
  },
  {
    path: 'survey-replies-statistics/:id?',
    name: 'admin:surveys:statistics',
    beforeEnter: multiGuard([PackagePermissionsGuard]),
    meta: { packagePermissions: [PACKAGE_PERMISSIONS.FEEDBACK], userTypes: [USER_TYPES.OWNER] },
    component: () => import(/* webpackChunkName: "surveys" */ '@/views/admin/marketing/surveys/SurveysRepliesStatistics.vue'),
  },
  {
    path: 'coupons',
    name: 'admin:coupons',
    beforeEnter: multiGuard([PackagePermissionsGuard]),
    meta: { packagePermissions: [PACKAGE_PERMISSIONS.COUPON], userTypes: [USER_TYPES.OWNER, USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "coupons" */ '@/views/admin/marketing/coupons/CouponsTable.vue'),
  },
  {
    path: 'marketing-events',
    name: 'admin:marketing-events',
    component: () => import(/* webpackChunkName: "coupons" */ '@/views/admin/marketing/marketing-events/MarketingEventsTable.vue'),
  },
  {
    path: 'campaigns',
    name: 'admin:campaigns',
    component: () => import(/* webpackChunkName: "coupons" */ '@/views/admin/marketing/campaigns/CampaignsTable.vue'),
  },
  {
    path: 'discounts',
    name: 'admin:discounts',
    beforeEnter: multiGuard([PackagePermissionsGuard]),
    meta: { packagePermissions: [PACKAGE_PERMISSIONS.DISCOUNT], userTypes: [USER_TYPES.OWNER, USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "discounts" */ '@/views/admin/marketing/discounts/DiscountsTable.vue'),
  },
  {
    path: 'wallet-packages',
    name: 'admin:wallet-packages',
    beforeEnter: multiGuard([PackagePermissionsGuard]),
    meta: { packagePermissions: [PACKAGE_PERMISSIONS.WALLET_PACKAGES], userTypes: [USER_TYPES.OWNER, USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "discounts" */ '@/views/admin/marketing/wallet-packages/WalletPackagesTable.vue'),
  },
  {
    path: 'newsletters',
    name: 'admin:newsletters',
    beforeEnter: multiGuard([PackagePermissionsGuard]),
    meta: { packagePermissions: [PACKAGE_PERMISSIONS.NEWSLETTER] },
    component: () => import(/* webpackChunkName: "newsletters" */ '@/views/admin/marketing/newsletters/NewsletterWizard.vue'),
  },
  {
    path: 'newsletters/edit/:id?',
    alias: 'newsletters/add',
    name: 'admin:newsletters:form',
    beforeEnter: multiGuard([PackagePermissionsGuard]),
    meta: { packagePermissions: [PACKAGE_PERMISSIONS.NEWSLETTER] },
    component: () => import(/* webpackChunkName: "newsletters" */ '@/views/admin/marketing/newsletters/NewsletterForm.vue'),
  },
  {
    path: 'banners',
    name: 'admin:banners',
    component: () => import(/* webpackChunkName: "newsletters" */ '@/views/admin/marketing/banners/BannersPopUps.vue'),
  },
  {
    path: 'wp-campaigns',
    name: 'admin:wp-campaigns',
    component: () => import(/* webpackChunkName: "whatsapp" */ '@/views/admin/marketing/whatsapp/WASetting.vue'),
  },
  {
    path: 'abandoned-carts',
    name: 'admin:abandoned-carts',
    alias: '/admin/abandoned-carts',
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "abandoned_carts" */ '@/views/admin/marketing/abandoned-carts/AbandonedCartsTable.vue'),
  },
]
